import * as React from "react";
import { useState } from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import { useLocation } from 'react-router-dom';
import TenantOnboardingForm from './TenantOnboardingForm';

const TenantOnboardingPage = (props) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const promoCode = queryParams.get('promo-code');

  return (
    <div className="App">
      <Container maxWidth={false}>
        <>
          <TenantOnboardingForm promoCode={promoCode}/>
        </>
      </Container>

    </div>
  );
}
export default TenantOnboardingPage;
